import { useLayoutEffect } from 'react';
import { useParams } from 'react-router-dom';

export const usePageTitle = (title: string) => {
  const { id } = useParams();

  useLayoutEffect(() => {
    document.title = id ? title || 'Untitled' : 'DocuMint';
  }, [title, id]);
};
